function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "m10.2965 13.8571v5.3334h2.2604v-5.3334zm4.5208 0v5.3334h2.2603v-5.3334zm-6.02775 8c0 .6312.51168 1.1429 1.14286 1.1429h12.03009c.6312 0 1.1428-.5117 1.1428-1.1429 0-.6311-.5116-1.1428-1.1428-1.1428h-12.03009c-.63119 0-1.14286.5117-1.14286 1.1428zm10.54845-8v5.3334h2.2604v-5.3334zm-2.1377-6.19032c-.7832-.41684-1.7225-.41684-2.5057 0l-5.4003 2.87412c-.31064.1653-.50475.4885-.50475.8404 0 .5258.42624.952.95203.952h12.41172c.5258 0 .952-.4262.952-.952 0-.3519-.1941-.6751-.5047-.8404z",
  fill: "currentColor"
});

function SvgLaw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#303030",
    height: 32,
    viewBox: "0 0 32 32",
    width: 32
  }, props), _ref);
}

export default "data:image/svg+xml;base64,";
export { SvgLaw as ReactComponent };